export const PRINTS_6X4_PROMOTION_KEY = 'prints_6x4';
